import SubmissionError from '../../../../error/SubmissionError'
import fetch from '../../../../utils/fetch'
import * as types from './mutation_types'
import Vue from 'vue'

export const create = ({ commit }, values) => {
  commit(types.DATABASECONNECTION_CREATE_SET_ERROR, '')
  commit(types.DATABASECONNECTION_CREATE_TOGGLE_LOADING)

  return fetch('database_connections', { method: 'POST', body: JSON.stringify(values) })
    .then((response) => {
      commit(types.DATABASECONNECTION_CREATE_TOGGLE_LOADING)
      Vue.prototype.$Swal({ // show notification with success
        type: 'success',
        title: Vue.prototype.$lang.t('notifications.store.savedTitle'),
        showConfirmButton: false,
        timer: 2500
      })
      return response.json()
    })
    .then((data) => {
      commit(types.DATABASECONNECTION_CREATE_SET_CREATED, data)
    })
    .catch((e) => {
      commit(types.DATABASECONNECTION_CREATE_TOGGLE_LOADING)

      if (e instanceof SubmissionError) {
        commit(types.DATABASECONNECTION_CREATE_SET_VIOLATIONS, e.errors)
        let errors = ''
        for (let key in e.errors) {
          if (key !== '_error') {
            errors += Vue.prototype.$lang.t('views.database.form.' + key) + ' -  ' + e.errors[key] + '<br />'
          }
        }
        Vue.prototype.$Swal({
          type: 'error',
          title: Vue.prototype.$lang.t('notifications.store.errorTitle'),
          html: errors,
          showConfirmButton: true
        })
        // eslint-disable-next-line
        // commit(types.DATABASECONNECTION_CREATE_SET_ERROR, e.errors._error)
        return
      }

      Vue.prototype.$Swal({
        type: 'error',
        title: Vue.prototype.$lang.t('notifications.store.errorTitle'),
        text: e.message,
        showConfirmButton: true,
        timer: 6000
      })
      console.log(e.message)
      // commit(types.DATABASECONNECTION_CREATE_SET_ERROR, e.message)
    })
}

export const reset = ({ commit }) => {
  commit(types.DATABASECONNECTION_CREATE_RESET)
}
